// extracted by mini-css-extract-plugin
export default {"carInfo":"carSummary_carInfo__eJPqi","imageContainer":"carSummary_imageContainer__B+LAu"};